import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  listItemButton: {
    py: 1.25,
    px: 2,
    mx: 0,
    my: 0,
    borderRadius: 0,
    borderLeft: '3px solid transparent',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    fontFamily: 'var(--font-data)',
    fontSize: '0.875rem',
    letterSpacing: '0.01em',
    transition: 'all 0.15s var(--easing)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--brand-coral)',
    },
  },
  listItemButtonCollapsed: {
    py: 1.25,
    px: 0,
    mx: 0,
    my: 0,
    borderRadius: 0,
    borderLeft: '3px solid transparent',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    transition: 'all 0.15s var(--easing)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--brand-coral)',
    },
  },
  navbarIcon: {
    fontSize: 18,
    marginRight: '12px',
    color: 'inherit',
    opacity: 0.9,
  },
  navbarIconCollapsed: {
    fontSize: 18,
    marginRight: 0,
    color: 'inherit',
    opacity: 0.9,
  },
  badge: {
    '& .MuiBadge-badge': {
      fontSize: '0.7rem',
      height: 18,
      width: 18,
      minWidth: 18,
      minHeight: 18,
      bgcolor: 'var(--brand-coral)',
      color: 'var(--text-inverse)',
      fontWeight: 600,
      right: 12,
      top: 2,
    },
  },
  badgeCollapsed: {
    '& .MuiBadge-badge': {
      fontSize: '0.6rem',
      height: 14,
      width: 14,
      minWidth: 14,
      minHeight: 14,
      bgcolor: 'var(--brand-coral)',
      color: 'var(--text-inverse)',
      fontWeight: 600,
      right: -2,
      top: -2,
      padding: 0,
    },
  },
};

export default styles;
